module.exports = __webpack_public_path__ + "j.no2.b98b98a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/j.no2.jpg
// module id = CwdU
// module chunks = 0